module.exports = __webpack_public_path__ + "img/Reporting-icon.35027e2c.svg";